import './bootstrap';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueClipboard from 'vue3-clipboard';
import VueEasyLightbox from 'vue-easy-lightbox';
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'
import VueLazyLoad from 'vue3-lazyload';

import { createApp } from 'vue';

window.topToastr = Swal.mixin({
  showConfirmButton: false,
  timer: 3000,
  position: 'top-end',
  toast: true,
  customClass: {
    popup: 'flex-row',
    container: 'top-alert'
  }
});

window.centerToastr = Swal.mixin({
  showConfirmButton: false,
  timer: 3000,
  position: 'center',
  toast: false
});

const app = createApp();

app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
})

app.use(VueEasyLightbox);
app.use(Vue3VideoPlayer, {
  lang: 'jp'
})
app.use(VueLazyLoad, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: '/imgs/loading.gif',
  attempt: 1
})

import Flash from './common/Flash.vue';
import CustomLoading from './common/CustomLoading.vue';
import ImageViewers from './common/ImageViewers.vue';
import VideoItem from './common/VideoItem.vue';
import TopSlider from './user/TopSlider.vue';
import TopVideoSlider from './user/TopVideoSlider.vue';
import Gallery from './user/Gallery.vue';
import Items from './user/Items.vue';
import ActorGallery from './user/ActorGallery.vue';
import ItemSlider from './user/ItemSlider.vue';
import Videos from './user/Videos.vue';
import ImageUpload from './admin/ImageUpload.vue';
import YoutubeVideos from './user/YoutubeVideos.vue';
import YoutubeVideoItem from './common/YoutubeVideoItem.vue';
import FavoriteVideos from './user/FavoriteVideos.vue';

app.component('loading', Loading);
app.component('flash', Flash);
app.component('custom-loading', CustomLoading);
app.component('image-viewers', ImageViewers);
app.component('video-item', VideoItem);
app.component('top-slider', TopSlider);
app.component('gallery', Gallery);
app.component('top-video-slider', TopVideoSlider);
app.component('items', Items);
app.component('actor-gallery', ActorGallery);
app.component('item-slider', ItemSlider);
app.component('videos', Videos);
app.component('image-upload', ImageUpload);
app.component('youtube-videos', YoutubeVideos);
app.component('youtube-video-item', YoutubeVideoItem);
app.component('favorite-videos', FavoriteVideos);

app.mount('#page_wrapper');
